"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInputCurrency = void 0;
const React = __importStar(require("react"));
const FormNumberInput_1 = require("../form-input/FormNumberInput");
const helpers_1 = require("../../../../entities/pricing/helpers");
const InlineMessage_1 = require("../../inline-message/InlineMessage");
const Spacer_1 = require("../../spacer/Spacer");
const FormInputCurrency = (props) => {
    const { type, widthtype, readOnly, showValidationError, currency, errorMessage } = props;
    if (type === 'number') {
        return React.createElement(FormNumberInput_1.FormNumberInput, Object.assign({}, props));
    }
    const containerClassList = ['form__input--container', `form__input--container--${type}`, 'form__input--input-currency-icon'];
    if (widthtype) {
        containerClassList.push(`form__input--container--${widthtype}`);
    }
    else {
        containerClassList.push('container');
    }
    const classList = ['form__input'];
    if (type) {
        classList.push(`form__input--${type}`);
    }
    if (showValidationError === true) {
        classList.push('form__input--currency-error');
    }
    if (readOnly) {
        classList.push('form__input--readonly');
    }
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: containerClassList.join(' ') },
            React.createElement("input", Object.assign({ className: classList.join(' ') }, props)),
            React.createElement("i", { style: { fontSize: 'var(--font-size-c1)' } }, (0, helpers_1.getCurrencySymbol)(currency))),
        React.createElement(Spacer_1.Spacer, null),
        errorMessage && React.createElement(InlineMessage_1.InlineError, { text: errorMessage }));
};
exports.FormInputCurrency = FormInputCurrency;
//# sourceMappingURL=FormInputCurrency.js.map